import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '@/shared/hooks/useAuth';
import { ProtectedRoute } from '@/shared/components/ProtectedRoute';
import { AuthLayout } from '@/app/layouts/AuthLayout';
import { DashboardLayout } from '@/app/layouts/DashboardLayout';
import { LoginPage } from '@/features/auth/pages/LoginPage';
import { RegisterPage } from '@/features/auth/pages/RegisterPage';
import { DashboardPage } from '@/features/dashboard/pages/DashboardPage';
import { PendingRestaurantsPage } from '@/features/restaurants/pages/PendingRestaurantsPage';
import { RejectedRestaurantsPage } from '@/features/restaurants/pages/RejectedRestaurantsPage';
import { RestaurantsPage } from '@/features/restaurants/pages/RestaurantsPage';
import { UsersPage } from '@/features/users/pages/UsersPage';
import { PromotionalBannersPage } from '@/features/admin/pages/PromotionalBannersPage';
import { RestaurantCategoriesPage } from '@/features/admin/pages/RestaurantCategoriesPage';
import { SettlementsPage } from '@/features/settlements/pages/SettlementsPage';
import { SettlementDetailPage } from '@/features/settlements/pages/SettlementDetailPage';
import { CashHandoversPage } from '@/features/cash/pages/CashHandoversPage';
import { CouponsAdminPage } from '@/features/admin/pages/CouponsAdminPage';
import { CouriersPage } from '@/features/couriers/pages/CouriersPage';
import { OrdersPage } from '@/features/orders/pages/OrdersPage';
import { AuditLogsPage } from '@/features/admin/pages/AuditLogsPage';
import { IncidentsPage } from '@/features/incidents/pages/IncidentsPage';
import { SystemConfigPage } from '@/features/admin/pages/SystemConfigPage';
import { RestaurantDetailPage } from '@/features/restaurants/pages/RestaurantDetailPage';
import { PrivacyClientPage } from '@/features/legal/pages/PrivacyClientPage';
import { PrivacyRestaurantPage } from '@/features/legal/pages/PrivacyRestaurantPage';
import { PrivacyRepartidorPage } from '@/features/legal/pages/PrivacyRepartidorPage';
import { DeleteDataPage } from '@/features/legal/pages/DeleteDataPage';
import { DeleteAccountPage } from '@/features/legal/pages/DeleteAccountPage';

function App() {
  // Inicializar autenticación y sincronizar con Firebase
  useAuth();

  return (
    <Routes>
      {/* Rutas públicas */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
      </Route>

      {/* Rutas protegidas */}
      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/restaurants/pending" element={<PendingRestaurantsPage />} />
        <Route path="/restaurants/rejected" element={<RejectedRestaurantsPage />} />
        <Route path="/restaurants" element={<RestaurantsPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/banners" element={<PromotionalBannersPage />} />
        <Route path="/categories" element={<RestaurantCategoriesPage />} />
        <Route path="/settlements" element={<SettlementsPage />} />
        <Route path="/settlements/:batchId" element={<SettlementDetailPage />} />
        <Route path="/cash-handovers" element={<CashHandoversPage />} />
        <Route path="/coupons" element={<CouponsAdminPage />} />
        <Route path="/couriers" element={<CouriersPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/audit-logs" element={<AuditLogsPage />} />
        <Route path="/incidents" element={<IncidentsPage />} />
        <Route path="/config" element={<SystemConfigPage />} />
        <Route path="/restaurants/:id" element={<RestaurantDetailPage />} />
      </Route>

      {/* Políticas de privacidad — rutas públicas sin autenticación */}
      <Route path="/privacy/client" element={<PrivacyClientPage />} />
      <Route path="/privacy/restaurant" element={<PrivacyRestaurantPage />} />
      <Route path="/privacy/repartidor" element={<PrivacyRepartidorPage />} />
      <Route path="/delete-data" element={<DeleteDataPage />} />
      <Route path="/delete-account" element={<DeleteAccountPage />} />

      {/* 404 */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;

